import {
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import colors from '@/config/colors';
import { useKeyListener } from '@/hooks/useKeyListener';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { GestureButton } from '../GestureButton';

const keyboardKeyStyle = StyleSheet.create({
  keyStyle: {
    borderRadius: 1,
    borderColor: 'rgba(0,0,0,0.33)',
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowOpacity: 0.3,
    shadowRadius: 1.8,
    elevation: 9,
  },
  wrongBg: {
    backgroundColor: colors.red,
  },
  correctBg: {
    backgroundColor: colors.primary,
  },
  lightColor: {
    color: colors.lightGrey,
  },
});

export function Key({
  currentOrder,
  letter,
  extraStyle,
  id,
  onCorrect,
  correct,
  onWrong,
  onWrongParam,
  wrongBoxChosen,
}) {
  const buttonMarginSize = useResponsiveWidth(0.3);
  const size = useResponsiveHeight(20) / 2 - buttonMarginSize * 2 - 1;
  const fontSize = size * 0.7;

  const responsiveStyles = StyleSheet.create({
    keyStyle: {
      width: size,
      aspectRatio: 1 / 1,
      margin: buttonMarginSize,
    },
    letterStyle: {
      fontSize: fontSize,
    },
  });

  const [isWrong, setIsWrong] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const onWrongClick = () => {
    setIsWrong(true);
    setTimeout(() => {
      setIsWrong(false);
    }, 500);
    onWrong(onWrongParam);
  };

  const onCorrectClick = () => {
    setIsCorrect(true);
    setShowHint(false);
    setTimeout(() => {
      setIsCorrect(false);
    }, 500);
    onCorrect(id, currentOrder, letter);
  };

  const onClick = () => {
    // Prevent double clicks by checking if we're already processing
    if (isProcessing) {
      return;
    }

    setIsProcessing(true);

    setTimeout(() => {
      setIsProcessing(false);
    }, 200);

    if (!correct) return onWrongClick();
    if (correct) onCorrectClick();
  };

  useEffect(() => {
    if (wrongBoxChosen >= 2) {
      if (correct) {
        setShowHint(true);
      }
    }
  }, [wrongBoxChosen]);

  useKeyListener({
    correct,
    letter,
    onCorrect: onCorrectClick,
    onWrong: onWrongClick,
    order: currentOrder,
  });

  return (
    <GestureButton onPress={onClick}>
      <View
        style={[
          keyboardKeyStyle.keyStyle,
          responsiveStyles.keyStyle,
          extraStyle,
          isWrong && keyboardKeyStyle.wrongBg,
          (showHint || isCorrect) && keyboardKeyStyle.correctBg,
        ]}
      >
        <Text
          className="font-abz"
          style={[
            responsiveStyles.letterStyle,
            (showHint || isWrong || isCorrect) && keyboardKeyStyle.lightColor,
          ]}
        >
          {letter}
        </Text>
      </View>
    </GestureButton>
  );
}
